import { CForm } from '@coreui/react'
import { useFormik } from 'formik';
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import * as Yup from 'yup';
import TopContext from '../components/topContext';
import ImageContainer from '../components/imageContainer';
import authService from '../../../../service/reactQueryServices/services/authService';
import { useMutation } from 'react-query';
import CustomValuesHook from '../../../../Hooks/customValuesHook';
import { toast } from 'react-toastify';


const SetPassword = () => {
  const { mutateAsync: resetPassword, isLoading } = useMutation("resetPassword", authService.resetPasswordService);

  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const location = useLocation()
  const params = useParams()
  const [state, setState] = CustomValuesHook({})

  const validation = Yup.object({
    password: Yup.string().required(t("ERRORS.PASSWORD_REQ") || "").min(8, t("TOAST.PASSWORD_LENGTH_ERROR") || ""),

  })

  useEffect(() => {
    handleSetToken()
  }, [])

  const handleSetToken = () => {
    if (location.search.indexOf("?token=") > -1) {
      setState({ token: location.search.split('=')[1] })
    }
  }

  const handleSubmit = async (values: { password: string }) => {

    try {
      const response = await resetPassword({
        password: values?.password,
        email: params?.email || "",
        token: state.token
      })

      if (response.successfullyChange) {
        navigate("/login")

      } else {
        toast.error(t("MESSAGES.RESET_PASSWORD_SET_PASSWORD_ERROR"))
      }

    } catch (error) {

    }
  }
  const formik = useFormik({
    validationSchema: validation,
    initialValues: { password: '' },
    onSubmit: handleSubmit,
  })

  return (


    <div className={`d-flex flex-row justify-content-between auth-form `}>
      <div className='section-rigth' >
        <TopContext />
        <div className='d-flex flex-row justify-content-center' >
          <div className='login-section login-form'>
            <div>

              <h4 className='icon-title d-flex flex-row justify-content-cener'><b>{t('TITLES.RESET_PASSWORD')}</b></h4>
              <p>{t("DESCRIPTIONS.SET_NEW_PASSWORD")}</p>
              <CForm onSubmit={formik.handleSubmit} >

                <div className="form-group">

                  <input type='password' name="password" id="exampleInputPassword1"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className='form-control' placeholder={t('Password') || ""} />
                  {formik.errors.password && formik.touched.password && <label className='label-danger '>{formik.errors.password}</label>}
                </div>
                <div className='d-flex flex-row justify-content-end'>
                  {/* <button className="btn btn-default mx-2"
                    type="submit" onClick={() => setState({ displayPage: "sendEmail" })} > {t('BACK')}</button> */}
                  <button className="btn btn-primary"
                    disabled={(!state.token || !formik.isValid || !formik.dirty || isLoading)}
                    type="submit" >  {isLoading ?
                      <div className="spinner-border" role="status" aria-hidden="true"></div> : t('ACTION.NEXT')}</button>

                </div>
              </CForm>
            </div>
            <div className='Copywriter d-flex flex-row justify-content-center' style={{ direction: 'ltr' }}>
              <p>{t('COPY_WRITE')}</p>
            </div>
          </div>
        </div>


      </div>
      <ImageContainer />
    </div>








  )
}

export default SetPassword